import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import QF24DateRsngePicker from './qf24-date-range-picker'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableHead from '@mui/material/TableHead'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import { DateTime } from 'luxon'
import NoQf24Data from './no-qf24-data'
import CollapseAlert from '../../components/common/collapse-alert'
import config from 'my-account-config'
import '../../styles/tables.css'
let initializeData = (qf24Data,
    startDate,
    endDate,
    t
) => {
    if (qf24Data !== undefined && qf24Data.length > 0) {
        return sliceData(qf24Data, startDate, endDate)
    }
    return []
}

const exportToCSV = (array, startDate, endDate) => {
    const rows = array.map(obj => {
        let date = DateTime.fromISO(obj.effectiveStartDate)
        const firstColumnValue = date.toFormat('M/d/yyyy')
        const secondColumnValue = date.toFormat('h:mm a').replace(/\u00A0/g, ' ') + ' - ' + date.plus({ hours: 1 }).toFormat('h:mm a').replace(/\u00A0/g, ' ')
        return [firstColumnValue, secondColumnValue, obj[Object.keys(obj)[1]]]
    })
    const csvContent = rows.map(row => row.join(",")).join("\n")
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    let filename = 'Market-pricing-' + startDate.toFormat('M-d-yyyy') + '-' +endDate.toFormat('M-d-yyyy')
    link.href = url
    link.download = `${filename}.csv`
    link.click()
    URL.revokeObjectURL(url)
}
let negativePrins = (value) => {
     return value > 0 
    ? '$' + value 
    : '($' + Math.abs(value).toString() + ')'
}
class QF24FormContainer extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {

        if (this.props.rateMetaData.rateMetaData.elapMarketRatesPerkWh === undefined || this.props.rateMetaData.rateMetaData.elapMarketRatesPerkWh.length <= 1) {
            return (
                <NoQf24Data t={this.props.t} />
            )
        }
        let slicedData = initializeData(this.props.rateMetaData.rateMetaData.elapMarketRatesPerkWh,
            this.props.rateMetaData.elapStartDate, this.props.rateMetaData.elapEndDate)

        return (
            <div>
                <QF24DateRsngePicker i18n={this.props.i18n} t={this.props.t} />
                <div className="d-md-block d-none mt-2 p-4" style={{ overflow: 'auto' }}>
                    <CollapseAlert title={this.props.t("Learn more about the Renewable Export Program.")}
                        collapsed={true}>
                        <ul>
                            <li>{this.props.t("Hourly prices displayed are the CAISO-administered Western Energy Imbalance Market External Load Aggregation Point real time hourly prices for SRP (\"ELAP”) determined as of the date on which the market price is initially made public.")}</li>
                            <li>{this.props.t("Prices displayed lag at least one calendar day.")}</li>
                            <li><a href={this.props.i18n.language === 'es' 
                                        ?  `${config.elapBaseUrlEs}/planes-de-precio/residencial-electrico/solar/programa-exportacion-renovable` 
                                        :  `${config.elapBaseUrl}/price-plans/residential-electric/solar/renewable-export-program`} 
                                        target='_blank' rel="noopener noreferrer">{this.props.t("Learn more")}</a> {this.props.t("about the program and view the terms and conditions.")}</li>
                        </ul>
                    </CollapseAlert>
                    <Table>
                        <TableHead >
                            <TableRow>
                                <TableCell className="border-0" padding="none">{this.props.t("Date")}</TableCell>
                                <TableCell className="border-0" padding="none">{this.props.t("Interval")}</TableCell>
                                <TableCell className="border-0" padding="none">{this.props.t("Price")}</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody className="srp-table-body">
                            {slicedData.map((row, index) => {
                                let date = DateTime.fromISO(row.effectiveStartDate)
                                return (
                                    <TableRow key={index} style={{ border: 'none' }}>
                                        <TableCell padding="none">{date.toFormat('M/d/yyyy')}</TableCell>
                                        <TableCell padding="none">{date.toFormat('h:mm a')} - {date.plus({ hours: 1 }).toFormat('h:mm a')}</TableCell>
                                        <TableCell padding="none">{negativePrins(row.value)}</TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                    <div className="d-none d-lg-block pt-2">
                        <div className="d-flex justify-content-end">


                            <button className='btn srp-btn btn-lightblue text-white' onClick={() => exportToCSV(initializeData(this.props.rateMetaData.rateMetaData.elapMarketRatesPerkWh,
                                this.props.rateMetaData.elapStartDate, this.props.rateMetaData.elapEndDate), this.props.rateMetaData.elapStartDate, this.props.rateMetaData.elapEndDate)}>Download to Excel</button>

                        </div>
                    </div>
                </div>
            </div>

        )
    }
}
function sliceData(data, startDate, endDate) {

    const slicedArray = data.filter(item => {
        const itemDate = new Date(item.effectiveStartDate)
        return itemDate >= startDate && itemDate <= endDate
    })
    return slicedArray.reverse()
}
const mapStateToProps = state => {
    return {
        rateMetaData: state.rateMetaData,
        ...state.accountInfo.usagePageUI
    }
}

const mapDispatchToProps = dispatch => {
    return {

    }
}


export default withTranslation("usageForms")(connect(mapStateToProps, mapDispatchToProps)(QF24FormContainer));